import React from 'react';
import { DatePicker } from 'material-ui-pickers';
import Header from './../Header';
import Footer from './../Footer'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import getPdf from './../../helpers/pdf'
import Typography from '@material-ui/core/Typography';
import { Link, Redirect } from 'react-router-dom';
import SelectInspections from './../controls/SelectInspections';
import { deleteNotification, clearRedirect, uploadFile, getNotification, saveNotification, removeUnsentFile, setNotificationSigned, loadInspectionsList, logout, removeAttachment, addAttachment, getAttachments} from './../../actions/actions';
import Chip from '@material-ui/core/Chip/Chip';
import Attachment from '@material-ui/icons/Attachment';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import { notification_attributes } from './../../helpers/trans';
import { styles }  from './../../helpers/classes';
import InputLabel from '@material-ui/core/InputLabel';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment';
import 'moment/locale/ru';
import OldBrowserMessage from './../OldBrowserMessage';

const kind = [
    {
        value: 'START',
        label: 'О начале строительно-монтажных работ',
    },
    {
        value: 'RENEW',
        label: 'О возобновлении строительно-монтажных работ',
    },
];



const blocks = {
    no_data: 'Данные уведомления',
    org_data: 'Данные заказчика',
    object_data: 'Данные объекта',
    decision_data: 'Данные решения',
    project_manager_data: 'Данные руководителя проекта',
    designer_data: 'Данные проектной документации',
    design_approval_data: 'Данные приказа, которым утверждена проектная документация',
    expertise_data: 'Наименование органа государственной экспертизы',
    developer_date: 'Данные лица, который будет выполнять строительно-монтажные работы',
    developer_constrains: 'Данные договора подряда. Нормативный срок строительства',
    responsible_data: 'Данные ответственного за производство работ на объекте',
    supervisor_data: 'Данные ответственного за проведение технического надзора',
    author_supervisor_data: 'Данные лица, ответственного за авторский надзор',
    budget_data: 'Стоимость строительно-монтажных работ',
    targeted_contributions : 'Перечисление целевых отчислений'
}

class Notification extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            fileUploadOpen:false,
            progress:false,
            sendDisabled:true,
            user: {},
            auth: false,
            redirect: null,
            document_url: '',
            document: {},
            sign_state: 'new',
            open: false,
            message:'',
            sign_message:'',
            sign_form: {
                notification_password:''
            },
            attachments: [],
            notification_form: {
                outgoing_number: '',
                kind:'',
                inspection_id: 0,
                registered_inspection_id: null,
                registered_inspection_name:'',
                inspection_name:'',
                client_org_name:'',
                client_org_country:'',
                client_org_state:'',
                client_org_region:'',
                client_org_city:'',
                client_org_street:'',
                client_org_phone:'',
                client_tax_comp_name:'',
                client_org_okpo:'',
                client_org_unn:'',
                client_org_conformity_certificate_index:'',
                client_org_certificate_date: null,
                object_name:'',
                object_country:'',
                object_state:'',
                object_region:'',
                object_city:'',
                object_street:'',
                object_block:'',
                object_building:'',
                object_address_approximate:'',
                object_address_lon:'',
                object_address_lat:'',
                org_id:'',
                renew_start_date: null,
                start_date:null,
                decision_org_name:'',
                decision_date: null,
                decision_index:'',
                project_manager_name:'',
                project_manager_position:'',
                project_manager_phone:'',
                order_index:'',
                order_date:null,
                design_company_name:'',
                design_company_country:'',
                design_company_state:'',
                design_company_region:'',
                design_company_city:'',
                design_company_street:'',
                design_company_phone:'',
                design_approval_company_name:'',
                design_approval_order_date: null,
                state_expertise_org_name:'',
                expertise_resolution_date: null,
                expertise_resolution_index:'',
                developer_name:'',
                developer_country:'',
                developer_state:'',
                developer_region:'',
                developer_city:'',
                developer_street:'',
                developer_phone:'',
                developer_conformity_certificate_number:'',
                certificate_category:'',
                developer_agreement_number :'',
                developer_agreement_date:null,
                developer_start: null,
                developer_term:'',
                responsible_org_name:'',
                responsible_org_position:'',
                responsible_org_phone:'',
                responsible_org_agreement_number:'',
                responsible_org_agreement_date: null,
                supervision_name:'',
                supervision_country:'',
                supervision_state:'',
                supervision_region:'',
                supervision_city:'',
                supervision_street:'',
                supervision_phone:'',
                supervision_certificate_number:'',
                supervision_certificate_category:'',
                author_supervision_name:'',
                author_supervision_country:'',
                author_supervision_state:'',
                author_supervision_region:'',
                author_supervision_city:'',
                author_supervision_street:'',
                author_supervision_phone:'',
                author_supervision_complexity_class:'',
                estimated_budget:0,
                state_budget:0,
                other_sources_budget:0,
                earmarked_contributions:0,
                payment_order_index:'',
                payment_order_date: null,
                description: ''
            }
        }
        moment.locale('ru');
    }

    logout = () => {
        this.props.logout();             
        this.setState({auth:false});
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user.role.indexOf('ROLE_BUILD_ORG')>=0 || user.role.indexOf('ROLE_BUILD_USER')>=0) {this.setState({auth :true, user: user});}
        if (this.props.inspections.length == 0) {
            this.props.loadInspections(user.token);
        }
        this.props.getNotification(this.props.match.params.id);
        this.props.getAttachments(user.token, this.props.match.params.id);
        this.props.clearRedirect();
    }

    componentWillReceiveProps(nextProps) {
        let form_data ={ ...this.state.notification_form, ...nextProps.notification_form}
        // let { inspection_id } = nextProps.notification_form;
        // if ((typeof inspection_id !== "undefined") && ('id' in inspection_id)) {
        //     form_data.inspection_id = inspection_id.id;
        // }
        this.setState(...this.state, ...nextProps, {notification_form: form_data});
    }

    onSelect = event => {
        let name;
        this.props.inspections.forEach(function(item){
            if(item.id == event.target.value){
            name =  item.title;
        }});
        this.setState({ notification_form: { ...this.state.notification_form, ...{ inspection_id: event.target.value, inspection_name: name}}});
    }
    onSelectRI = event => {
        let name;
        this.props.inspections.forEach(function(item){
            if(item.id == event.target.value){
                name =  item.title;
            }});
        this.setState({ notification_form: { ...this.state.notification_form, ...{ registered_inspection_id: event.target.value, registered_inspection_name: name}}});
    }

    handleSendFile = () => {
        this.setState({progress:true});
        let password_crypto = this.state.sign_form.notification_password_crypto;
        // Файл уведомления
        let url = this.props.document_url;

        var mystr =window.location.href;
        var wheresWaldo = mystr.indexOf("/#"); // 7
        var stringTwo = mystr.slice(0,wheresWaldo  );
        var local_url = mystr.slice(0,wheresWaldo  );
        stringTwo=stringTwo+url;

        let result = this.parseApplet(password_crypto,local_url, stringTwo,this.props.match.params.id);
        console.log(result);
        try {
            if (typeof result === "undefined") {
                this.setState({sign_message: 'Проверьте правильность работы апплетов в броузере.', progress:false});
            } else {
                let code = parseInt(result.code);
            if (code == 0) {
                this.props.setNotificationSigned(this.props.match.params.id, this.state.user.token);
                this.setState({ open: false, progress:false });
            } else {
                this.setState({sign_message: result.message, progress:false});
            }
        }
        } catch (e){
            this.setState({sign_message: e.message, progress:false});
        }
    }

    parseApplet = (password_crypto,url,stringTwo, id) => {

        var my_app = document.getElementById('appletAvSend');
        // var my_app = document.applets[0];

        try {
            var ser_num = my_app.get_serNum(password_crypto,url,stringTwo, id);
            return JSON.parse(ser_num);
        } catch (e) {
            console.log(e)
        }
    }

    onFileFormChange = (input) => {
        let data = {[input.name]: input.value };
        let currentData = this.state.sign_form;
        this.setState({sign_form: {...currentData, ...data}});
    }

    handleClickOpen = () => {
        // check required
        let canSign = true;
        let message = [];

        if (this.state.notification_form.inspection_id === 0) {
            message.push('Hе указано заначенине ' + notification_attributes.inspection);
            canSign = false;
        }
        if (this.state.notification_form.kind == 'RENEW' && this.state.notification_form.registered_inspection_id === null) {
            message.push('Hе указано заначенине ' + notification_attributes.registered_inspection_id);
            canSign = false;
        }
        let allowed = [
            'state_budget',
            'author_supervision_state',
            'author_supervision_region',
            'supervision_state',
            'supervision_region',
            'developer_state',
            'developer_region',
            'design_company_state',
            'design_company_region',
            'client_org_state',
            'client_org_region',
            'inspection',                               
            'registered_inspection_name',
            'inspection_name',
            'object_city',
            'object_street',
            'object_block',
            'object_building',
            'object_address_approximate',
            'undefined',
            'object_address_lon',
            'object_address_lat',
            'inspection_id',
            'registered_inspection_id',
            'other_sources_budget',
            'notification_replies',
            'description',          
            'decision_org_name',
            'decision_date',
            'decision_index',
            'developer_agreement_number',
            'developer_agreement_date',
            'developer_start',
            'developer_term',
            'renew_start_date',
            'start_date',
            'project_manager_name',
            'project_manager_position',
            'project_manager_phone',
            'order_index',
            'order_date',
            'design_company_name',
            'design_company_country',
            'design_company_state',
            'design_company_region',
            'design_company_city',
            'design_company_street',
            'design_company_phone',
            'design_approval_company_name',
            'design_approval_order_date',
            'state_expertise_org_name',
            'expertise_resolution_date',
            'expertise_resolution_index',
            'developer_name',
            'developer_country',
            'developer_state',
            'developer_region',
            'developer_city',
            'developer_street',
            'developer_phone',
            'developer_conformity_certificate_number',
            'certificate_category',
            'developer_agreement_number',
            'developer_agreement_date',
            'responsible_org_name',
            'responsible_org_position',
            'responsible_org_phone',
            'responsible_org_agreement_number',
            'responsible_org_agreement_date',
            'supervision_name',
            'supervision_country',
            'supervision_state',
            'supervision_region',
            'supervision_city',
            'supervision_street',
            'supervision_phone',
            'supervision_certificate_number',
            'supervision_certificate_category',
            'author_supervision_name',
            'author_supervision_country',
            'author_supervision_state',
            'author_supervision_region',
            'author_supervision_city',
            'author_supervision_street',
            'author_supervision_phone',
            'author_supervision_complexity_class',
            'estimated_budget',
            'state_budget',
            'earmarked_contributions',
            'payment_order_index',
            'payment_order_date'
        ];

        if (this.state.notification_form.kind !== 'RENEW') {
            allowed.push('renew_start_date');
        }
        if (this.state.notification_form.kind !== 'START') {
            allowed.push('start_date');
        }
        for (var key in this.state.notification_form) {
            if( allowed.indexOf(key) == -1 && (this.state.notification_form[key] == null || this.state.notification_form[key] == '')) {
                message.push('Не указано заначенине ' + notification_attributes[key]);
                canSign = false;
            }
        }
        message = message.join('. ');
        if (!canSign) {
           this.setState({message: message});
        }  else {
        var doc = getPdf({...this.state.notification_form, ...{full_name: this.state.user.eds_name}});
        this.setState({document:doc});
        this.props.uploadFile(doc, this.props.match.params.id, this.state.notification_form, this.state.user.token);
        }
    };

    handleClose = () => {
        this.props.removeUnsentFile(this.props.match.params.id);
    };


    handleChange = event => {
        let data = { [event.target.name]: event.target.value } ;
        let currentData = this.state.notification_form;
        this.setState({ notification_form:{ ...currentData, ...data}});
    };

    updateInput = input => {
        let data = {[input.name]: input.value } ;
        let currentData = this.state.notification_form;
        this.setState({notification_form:{ ...currentData, ...data}});
    }

    updateStartDate = (date) => {
        this.updateDateInput(date, 'start_date')
    }

    updateRenewStartDate = (date) => {
        this.updateDateInput(date, 'renew_start_date')
    }

    updateDecisionDate = (date) => {
        this.updateDateInput(date, 'decision_date')
    }

    updateOrderDate = (date) => {
        this.updateDateInput(date, 'order_date')
    }

    updateExpertiseResolutionDate = (date) => {
        this.updateDateInput(date, 'expertise_resolution_date')
    }

    updateDeveloperAgreementDate = (date) => {
        this.updateDateInput(date, 'developer_agreement_date')
    }

    updateDeveloperStart = (date) => {
        this.updateDateInput(date, 'developer_start')
    }

    updatePaymentOrderDate = (date) => {
        this.updateDateInput(date, 'payment_order_date')
    }

    updateClientOrgCertificateDate = (date) => {
        this.updateDateInput(date, 'client_org_certificate_date')
    }

    updateResponsibleOrgAgreementDate = (date) => {
        this.updateDateInput(date, 'responsible_org_agreement_date')
    }

    updateDesignApprovalOrderDate = (date) => {
        this.updateDateInput(date, 'design_approval_order_date')
    }


    updateDateInput = (date, name) => {
        console.log(date);
        console.log(name);
        let value = date.toISOString().split('T')[0];
        console.log(value);
        let data = {[name]: value } ;
        let currentData = this.state.notification_form;
       this.setState({notification_form:{ ...currentData, ...data}});
    }
    handleSave = () => {
        this.props.saveNotification(this.props.match.params.id, this.state.notification_form, this.state.user.token);
        this.setState({sendDisabled:false})
        // let doc = getPdf(this.state.notification_form);
        // this.setState({document:doc});
    }

    handleDelete = () => {
        this.props.deleteNotification(this.props.match.params.id, this.state.user.token);
    }

    onClientNameBlur = (e) => {
        console.log(e.target.value);
    }

    showForm = () => {
        this.setState({fileUploadOpen: true})
    }

    fileUpload = (e) => {
        e.preventDefault();
        console.log();
        const data = new FormData(e.target);
        if(e.target['attachment'].files.length > 0) {
            data.append('attachment', e.target['attachment'].files[0])
        }
        this.setState({fileUploadOpen : false});
        this.props.addAttachment('', this.props.match.params.id, data);
    }

    render() {
        const { classes, theme } = this.props;
        const { open } = this.state;
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        if (this.props.redirect !== null) {
            console.log(this.props.redirect);
            return (<Redirect to={{
                pathname: `/${this.props.redirect}`,
                state: { message: this.props.message }
            }} />)
        }

        return (
            <div>
                <Header link={{title: this.state.user.org, to:'/org-cabinet/'}}/>
                <Toolbar>
                    <Button style={{ display: 'inline-block', border: '1px solid transparent' }} component={Link} to={{ pathname: '/org-cabinet/'}}>Вернуться</Button>
                    <Button style={{ display: 'inline-block', border: '1px solid transparent' }} onClick={this.logout}>Выйти</Button>
                </Toolbar>
                <main>
                    <Paper style={{padding:'4em'}}>
                        <OldBrowserMessage />
                    <form id="i_notification">
                        <fieldset style={{border:'none'}} disabled={this.props.notification_form.status == 'SIGNED'}>
                        <Paper style={{padding:'1em', marginBottom:"1em"}}>
                            <Typography variant="h6" >{blocks.no_data}<sup>1</sup></Typography>
                            <InputLabel
                                htmlFor='kind-on-notification'
                                disabled={this.props.notification_form.status == 'SIGNED'}
                                className={classes.notificationPageLabel}>
                                {'Тип уведомления'}
                            </InputLabel>
                                <TextField
                               disabled={this.props.notification_form.status == 'SIGNED'}
                               id="kind-on-notification"
                               select
                               name="kind"
                               style={{ margin: 8 }}
                               value={this.state.notification_form.kind}
                               onChange={this.handleChange}
                               fullWidth
                               margin="dense"
                               SelectProps={{
                            MenuProps: { className: classes.menu,
                            },
                          }}
                    >
                        {kind.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <InputLabel style={{fontSize:'0.8em',marginLeft:'0.2em'}} htmlFor="insp-select" >Инспекция</InputLabel>
                    <SelectInspections disabled={this.props.notification_form.status == 'SIGNED'}
                                       id="insp-select"
                                       name="inspection_id"
                                       onChange={ this.onSelect }
                                       items={ this.props.inspections }
                                       value={ this.state.notification_form.inspection_id }/>
                    <p><a target="_blank" href="http://pravo.by/document/?guid=12551&p0=C21800343&p1=1">Условия подачи уведомлений регламентируются Постановлением Совета министров Республики Беларусь от 8 мая 2018  №343</a></p>
                    <InputLabel htmlFor='outgoing_number' className={classes.notificationPageLabel} >{notification_attributes.outgoing_number}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="outgoing_number"
                               name="outgoing_number"
                               value={this.state.notification_form.outgoing_number}
                               InputLabelProps={{shrink: true,}}
                    />
                        </Paper>
                    <Paper style={{padding:'1em', marginBottom:"1em"}}>
                        <Typography variant="h6" >{blocks.org_data}</Typography>
                    <InputLabel htmlFor='client_org_name' className={classes.notificationPageLabel} >{notification_attributes.client_org_name}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               inputProps={{'onBlur':this.onClientNameBlur}}
                               id="client_org_name"
                               name="client_org_name"
                               value={this.state.notification_form.client_org_name}
                               InputLabelProps={{shrink: true,}}
                    />
                    <InputLabel htmlFor='client_org_country' className={classes.notificationPageLabel}>{notification_attributes.client_org_country}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               maxLength={50}
                               id="client_org_country"
                               name="client_org_country"
                               margin="dense"
                               value={this.state.notification_form.client_org_country}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_state' className={classes.notificationPageLabel}>{notification_attributes.client_org_state}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               maxLength={50}
                               id="client_org_state"
                               name="client_org_state"
                               margin="dense"
                               value={this.state.notification_form.client_org_state}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_region' className={classes.notificationPageLabel}>{notification_attributes.client_org_region}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="client_org_region"
                               name="client_org_region"
                               margin="dense"
                               value={this.state.notification_form.client_org_region}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_city' className={classes.notificationPageLabel}>{notification_attributes.client_org_city}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="client_org_city"
                               name="client_org_city"
                               margin="dense"
                               value={this.state.notification_form.client_org_city}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_street' className={classes.notificationPageLabel}>{notification_attributes.client_org_street}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="client_org_street"
                               name="client_org_street"
                               value={this.state.notification_form.client_org_street}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_phone' className={classes.notificationPageLabel} >{notification_attributes.client_org_phone}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               placeholder="+375111111111"
                               id="client_org_phone"
                               name="client_org_phone"
                               value={this.state.notification_form.client_org_phone}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_tax_comp_name' className={classes.notificationPageLabel}>{notification_attributes.client_tax_comp_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="client_tax_comp_name"
                               name="client_tax_comp_name"
                               margin="dense"
                               value={this.state.notification_form.client_tax_comp_name}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_okpo' className={classes.notificationPageLabel} >{notification_attributes.client_org_okpo}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               placeholder="0909865"
                               id="client_org_okpo"
                               name="client_org_okpo"
                               margin="dense"
                               value={this.state.notification_form.client_org_okpo}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_unn' className={classes.notificationPageLabel} >{notification_attributes.client_org_unn}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               placeholder="456779"
                               id="client_org_unn"
                               name="client_org_unn"
                               margin="dense"
                               value={this.state.notification_form.client_org_unn}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_conformity_certificate_index' className={classes.notificationPageLabel} >{notification_attributes.client_org_conformity_certificate_index}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="client_org_conformity_certificate_index"
                               name="client_org_conformity_certificate_index"
                               margin="dense"
                               value={this.state.notification_form.client_org_conformity_certificate_index}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='client_org_certificate_date' className={classes.notificationPageLabel}>{notification_attributes.client_org_certificate_date}</InputLabel>
                    <DatePicker
                               onChange={this.updateClientOrgCertificateDate}
                               fullWidth
                               format='DD.MM.YYYY'
                               id="client_org_certificate_date"
                               name="client_org_certificate_date"
                               value={this.state.notification_form.client_org_certificate_date}
                               InputLabelProps={{ shrink: true,  }}
                    />
                    </Paper>
                    <Paper style={{padding:"1em", marginBottom:"1em"}}>
                        <Typography variant="h6">{blocks.object_data}</Typography>
                        <InputLabel htmlFor='object_name' className={classes.notificationPageLabel}>{notification_attributes.object_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_name"
                               name="object_name"
                               margin="dense"
                               value={this.state.notification_form.object_name}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_country' className={classes.notificationPageLabel}>{notification_attributes.object_country}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_country"
                               name="object_country"
                               margin="dense"
                               value={this.state.notification_form.object_country}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_state' className={classes.notificationPageLabel} >{notification_attributes.object_state}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_state"
                               name="object_state"
                               margin="dense"
                               value={this.state.notification_form.object_state}
                               InputLabelProps={{shrink: true,}}
                    />
                    <InputLabel htmlFor='object_region' className={classes.notificationPageLabel} >{notification_attributes.object_region}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_region"
                               name="object_region"
                               margin="dense"
                               value={this.state.notification_form.object_region}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_city' className={classes.notificationPageLabel}>{notification_attributes.object_city}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_city"
                               name="object_city"
                               margin="dense"
                               value={this.state.notification_form.object_city}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_street' className={classes.notificationPageLabel}>{notification_attributes.object_street}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_street"
                               name="object_street"
                               margin="dense"
                               value={this.state.notification_form.object_street}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_block' className={classes.notificationPageLabel}>{notification_attributes.object_block}</InputLabel>
                    <TextField

                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_block"
                               name="object_block"
                               margin="dense"
                               value={this.state.notification_form.object_block}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_building' className={classes.notificationPageLabel} >{notification_attributes.object_building}</InputLabel>
                    <TextField

                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_building"
                               name="object_building"
                               margin="dense"
                               value={this.state.notification_form.object_building}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='object_address_approximate' className={classes.notificationPageLabel} >{notification_attributes.object_address_approximate}</InputLabel>
                    <TextField onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="object_address_approximate"
                               name="object_address_approximate"
                               margin="dense"
                               value={this.state.notification_form.object_address_approximate}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                        {/*<TextField
                                   onChange={e => this.updateInput(e.target)}
                                   label={notification_attributes.object_address_lon}
                                   fullWidth
                                   id="object_address_lon"
                                   name="object_address_lon"
                                   margin="dense"
                                   value={this.state.notification_form.object_address_lon}
                                   InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <TextField
                                   onChange={e => this.updateInput(e.target)}
                                   label={notification_attributes.object_address_lat}
                                   fullWidth
                                   id="object_address_lat"
                                   name="object_address_lat"
                                   margin="dense"
                                   value={this.state.notification_form.object_address_lat}
                                   InputLabelProps={{
                            shrink: true,
                          }}
                        />  */} </Paper>

                        {(this.state.notification_form.kind ==='RENEW') &&
                        (<Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <InputLabel disabled={(this.props.disabled || this.state.notification_form.kind !== 'RENEW') } htmlFor='renew_start_date' className={classes.notificationPageLabel}>{notification_attributes.renew_start_date}</InputLabel>
                    <DatePicker disabled={(this.props.disabled || this.state.notification_form.kind !== 'RENEW') }
                               onChange={this.updateRenewStartDate}
                               fullWidth
                               format='DD.MM.YYYY'
                               id="renew_start_date"
                               name="renew_start_date"
                               margin="dense"
                               value={this.state.notification_form.renew_start_date}
                               InputLabelProps={{shrink: true,}}
                    />
                        <InputLabel style={{fontSize:'0.8em',marginLeft:'0.2em'}} htmlFor="reg-insp-select" >{ notification_attributes.registered_inspection_id}</InputLabel>
                        <SelectInspections disabled={this.props.notification_form.status == 'SIGNED'}
                                           id="reg-insp-select"
                                           name="registered_inspection_id"
                                           onChange={ this.onSelectRI }
                                           items={ this.props.inspections }
                                           value={ this.state.notification_form.registered_inspection_id }/>
                        </Paper>
                        )}

                        {(this.state.notification_form.kind ==='START') &&
                        (<Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <InputLabel htmlFor='start_date' className={classes.notificationPageLabel}>{notification_attributes.start_date}</InputLabel>
                                <DatePicker
                                           onChange={this.updateStartDate}
                                           fullWidth
                                           format='DD.MM.YYYY'
                                           id="start_date"
                                           name="start_date"
                                           margin="dense"
                                           value={this.state.notification_form.start_date}
                                           InputLabelProps={{shrink: true,}}
                                />
                            </Paper>
                        )}


                    <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6">{blocks.decision_data}</Typography>
                    <InputLabel htmlFor='decision_org_name' className={classes.notificationPageLabel} >{notification_attributes.decision_org_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="decision_org_name"
                               name="decision_org_name"
                               margin="dense"
                               value={this.state.notification_form.decision_org_name}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='decision_org_name' className={classes.notificationPageLabel} >{notification_attributes.decision_date}</InputLabel>
                    <DatePicker
                               onChange={this.updateDecisionDate}
                               fullWidth
                               format='DD.MM.YYYY'
                               id="decision_date"
                               name="decision_date"
                               value={this.state.notification_form.decision_date}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='decision_index' className={classes.notificationPageLabel} >{notification_attributes.decision_index}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="decision_index"
                               name="decision_index"
                               value={this.state.notification_form.decision_index}
                               InputLabelProps={{ shrink: true }}
                    />
                    </Paper>
                        <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6">{blocks.project_manager_data}</Typography>
                    <InputLabel htmlFor='project_manager_name' className={classes.notificationPageLabel}>{notification_attributes.project_manager_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="project_manager_name"
                               name="project_manager_name"
                               value={this.state.notification_form.project_manager_name}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='project_manager_position' className={classes.notificationPageLabel}>{notification_attributes.project_manager_position}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="project_manager_position"
                               name="project_manager_position"
                               value={this.state.notification_form.project_manager_position}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='project_manager_phone' className={classes.notificationPageLabel}>{notification_attributes.project_manager_phone}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               placeholder="+375111111111"
                               id="project_manager_phone"
                               name="project_manager_phone"
                               value={this.state.notification_form.project_manager_phone}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='order_index' className={classes.notificationPageLabel}>{notification_attributes.order_index}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="order_index"
                               name="order_index"
                               value={this.state.notification_form.order_index}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='order_date' className={classes.notificationPageLabel}>{notification_attributes.order_date}</InputLabel>
                    <DatePicker
                        onChange={this.updateOrderDate}
                        fullWidth
                        format='DD.MM.YYYY'
                        id="order_date"
                        name="order_date"
                        value={this.state.notification_form.order_date}
                        InputLabelProps={{shrink: true}}
                    />
                            </Paper>
                        <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6">{blocks.designer_data}</Typography>
                    <InputLabel htmlFor='design_company_name' className={classes.notificationPageLabel} >{notification_attributes.design_company_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_name"
                               name="design_company_name"
                               value={this.state.notification_form.design_company_name}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='design_company_country' className={classes.notificationPageLabel} >{notification_attributes.design_company_country}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_country"
                               name="design_company_country"
                               value={this.state.notification_form.design_company_country}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='design_company_country' className={classes.notificationPageLabel} >{notification_attributes.design_company_state}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_state"
                               name="design_company_state"
                               value={this.state.notification_form.design_company_state}
                               InputLabelProps={{ shrink: true }}
                    />
                    <InputLabel htmlFor='design_company_region' className={classes.notificationPageLabel}>{notification_attributes.design_company_region}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_region"
                               name="design_company_region"
                               value={this.state.notification_form.design_company_region}
                               InputLabelProps={{shrink: true  }}
                    />
                    <InputLabel htmlFor='design_company_city' className={classes.notificationPageLabel}>{notification_attributes.design_company_city}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_city"
                               name="design_company_city"
                               value={this.state.notification_form.design_company_city}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='design_company_street' className={classes.notificationPageLabel}>{notification_attributes.design_company_street}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_street"
                               name="design_company_street"
                               value={this.state.notification_form.design_company_street}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='design_company_phone' className={classes.notificationPageLabel}>{notification_attributes.design_company_phone}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="design_company_phone"
                               placeholder="+375111111111"
                               name="design_company_phone"
                               value={this.state.notification_form.design_company_phone}
                               InputLabelProps={{shrink: true}}
                    />
                    </Paper>
                        <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6">{blocks.design_approval_data}</Typography>
                    <InputLabel htmlFor='design_approval_company_name' className={classes.notificationPageLabel} >{notification_attributes.design_approval_company_name}</InputLabel>
                    <TextField
                               fullWidth
                               onChange={e => this.updateInput(e.target)}
                               id="design_approval_company_name"
                               name="design_approval_company_name"
                               margin="dense"
                               value={this.state.notification_form.design_approval_company_name}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='design_approval_order_date' className={classes.notificationPageLabel}>{notification_attributes.design_approval_order_date}</InputLabel>
                    <DatePicker
                               onChange={this.updateDesignApprovalOrderDate}
                               fullWidth
                               format='DD.MM.YYYY'
                               id="design_approval_order_date"
                               name="design_approval_order_date"
                               value={this.state.notification_form.design_approval_order_date}
                               InputLabelProps={{shrink: true}}
                    />
                    </Paper>
                        <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6">{blocks.expertise_data}</Typography>
                    <InputLabel htmlFor='state_expertise_org_name' className={classes.notificationPageLabel} >{notification_attributes.state_expertise_org_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="state_expertise_org_name"
                               name="state_expertise_org_name"
                               value={this.state.notification_form.state_expertise_org_name}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='state_expertise_org_name' className={classes.notificationPageLabel} >{notification_attributes.expertise_resolution_date}</InputLabel>
                    <DatePicker
                               fullWidth
                               onChange={this.updateExpertiseResolutionDate}
                               format='DD.MM.YYYY'
                               id="expertise_resolution_date"
                               name="expertise_resolution_date"
                               value={this.state.notification_form.expertise_resolution_date}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='expertise_resolution_index' className={classes.notificationPageLabel}>{notification_attributes.expertise_resolution_index}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="expertise_resolution_index"
                               name="expertise_resolution_index"
                               value={this.state.notification_form.expertise_resolution_index}
                               InputLabelProps={{shrink: true}}
                    />
                            </Paper>
                        <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6" componrnt="h3">{blocks.developer_date}</Typography>
                    <InputLabel htmlFor='developer_name' className={classes.notificationPageLabel}>{notification_attributes.developer_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="developer_name"
                               name="developer_name"
                               value={this.state.notification_form.developer_name}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='developer_country' className={classes.notificationPageLabel} >{notification_attributes.developer_country}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="developer_country"
                               name="developer_country"
                               value={this.state.notification_form.developer_country}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='developer_state' className={classes.notificationPageLabel} >{notification_attributes.developer_state}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="developer_state"
                               name="developer_state"
                               value={this.state.notification_form.developer_state}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='developer_region' className={classes.notificationPageLabel} >{notification_attributes.developer_region}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="developer_region"
                               name="developer_region"
                               value={this.state.notification_form.developer_region}
                               InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='developer_city' className={classes.notificationPageLabel} >{notification_attributes.developer_city}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="developer_city"
                               name="developer_city"
                               value={this.state.notification_form.developer_city}
                               InputLabelProps={{  shrink: true}}
                    />
                    <InputLabel htmlFor='developer_street' className={classes.notificationPageLabel}>{notification_attributes.developer_street}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="developer_street"
                               name="developer_street"
                               value={this.state.notification_form.developer_street}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='developer_phone' className={classes.notificationPageLabel}>{notification_attributes.developer_phone}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        placeholder="+375111111111"
                        id="developer_phone"
                        name="developer_phone"
                        value={this.state.notification_form.developer_phone}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='developer_conformity_certificate_number' className={classes.notificationPageLabel}>{notification_attributes.developer_conformity_certificate_number}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="developer_conformity_certificate_number"
                        name="developer_conformity_certificate_number"
                        //className={classes.textField}
                        margin="dense"
                        value={this.state.notification_form.developer_conformity_certificate_number}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='certificate_category' className={classes.notificationPageLabel}>Какой категории</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        placeholder="первой"
                        InputProps={{'max':6}}
                        id="certificate_category"
                        name="certificate_category"
                        value={this.state.notification_form.certificate_category}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='developer_agreement_number' className={classes.notificationPageLabel}>{notification_attributes.developer_agreement_number}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="developer_agreement_number"
                        name="developer_agreement_number"
                        margin="dense"
                        value={this.state.notification_form.developer_agreement_number}
                        InputLabelProps={{ shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='developer_agreement_date' className={classes.notificationPageLabel}>{notification_attributes.developer_agreement_date}</InputLabel>
                    <DatePicker
                        format='DD.MM.YYYY'
                        onChange={this.updateDeveloperAgreementDate}
                        fullWidth
                        id="developer_agreement_date"
                        name="developer_agreement_date"
                        margin="dense"
                        value={this.state.notification_form.developer_agreement_date}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />       </Paper>

                <Paper style={{padding:"1em", marginBottom: "1em"}}>
                     <Typography variant="h6" componrnt="h3">{blocks.developer_constrains}
                     </Typography>
                    <InputLabel htmlFor='developer_start' className={classes.notificationPageLabel}>{notification_attributes.developer_start}</InputLabel>
                    <DatePicker
                        format='DD.MM.YYYY'
                        onChange={this.updateDeveloperStart}
                        fullWidth
                        id="developer_start"
                        name="developer_start"
                        margin="dense"
                        value={this.state.notification_form.developer_start}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='developer_term' className={classes.notificationPageLabel}>{notification_attributes.developer_term}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="developer_term"
                        name="developer_term"
                        margin="dense"
                        value={this.state.notification_form.developer_term}
                        placeholder="количество месяцев"
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                </Paper>
                <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6" componrnt="h3">{blocks.responsible_data}</Typography>
                    <InputLabel htmlFor='responsible_org_name' className={classes.notificationPageLabel} >{notification_attributes.responsible_org_name}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="responsible_org_name"
                        name="responsible_org_name"
                        margin="dense"
                        value={this.state.notification_form.responsible_org_name}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='responsible_org_position' className={classes.notificationPageLabel}>{notification_attributes.responsible_org_position}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="responsible_org_position"
                        name="responsible_org_position"
                        margin="dense"
                        value={this.state.notification_form.responsible_org_position}
                        InputLabelProps={{ shrink: true,}}
                    />
                    <InputLabel htmlFor='responsible_org_phone' className={classes.notificationPageLabel}>{notification_attributes.responsible_org_phone}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               placeholder="+375111111111"
                               id="responsible_org_phone"
                               name="responsible_org_phone"
                               margin="dense"
                               value={this.state.notification_form.responsible_org_phone}
                               InputLabelProps={{shrink: true,   }}
                    />
                    <InputLabel htmlFor='responsible_org_agreement_number' className={classes.notificationPageLabel}>{notification_attributes.responsible_org_agreement_number}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="responsible_org_agreement_number"
                               name="responsible_org_agreement_number"
                               value={this.state.notification_form.responsible_org_agreement_number}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='responsible_org_agreement_date' className={classes.notificationPageLabel}>{notification_attributes.responsible_org_agreement_date}</InputLabel>
                    <DatePicker
                               format='DD.MM.YYYY'
                               onChange={this.updateResponsibleOrgAgreementDate}
                               fullWidth
                               id="responsible_org_agreement_date"
                               name="responsible_org_agreement_date"
                               margin="dense"
                               value={this.state.notification_form.responsible_org_agreement_date}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    </Paper>

                    <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6" componrnt="h3">{blocks.supervisor_data}</Typography>
                    <InputLabel htmlFor='supervision_name' className={classes.notificationPageLabel} >{notification_attributes.supervision_name}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_name"
                               name="supervision_name"
                               margin="dense"
                               value={this.state.notification_form.supervision_name}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_country' className={classes.notificationPageLabel} >{notification_attributes.supervision_country}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_country"
                               name="supervision_country"
                        //className={classes.textField}
                               margin="dense"
                               value={this.state.notification_form.supervision_country}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_state' className={classes.notificationPageLabel} >{notification_attributes.supervision_state}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_state"
                               name="supervision_state"
                               margin="dense"
                               value={this.state.notification_form.supervision_state}
                               InputLabelProps={{shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_region' className={classes.notificationPageLabel}>{notification_attributes.supervision_region}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_region"
                               name="supervision_region"
                               margin="dense"
                               value={this.state.notification_form.supervision_region}
                               InputLabelProps={{ shrink: true,  }}
                    />
                    <InputLabel htmlFor='supervision_city' className={classes.notificationPageLabel} >{notification_attributes.supervision_city}</InputLabel>
                    <TextField

                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_city"
                               name="supervision_city"
                               margin="dense"
                               value={this.state.notification_form.supervision_city}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_street' className={classes.notificationPageLabel} >{notification_attributes.supervision_street}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_street"
                               name="supervision_street"
                               margin="dense"
                               value={this.state.notification_form.supervision_street}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_phone' className={classes.notificationPageLabel}>{notification_attributes.supervision_phone}</InputLabel>
                    <TextField
                               onChange={e => this.updateInput(e.target)}
                               fullWidth
                               id="supervision_phone"
                               name="supervision_phone"
                               placeholder="+375111111111"
                               margin="dense"
                               value={this.state.notification_form.supervision_phone}
                               InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_certificate_number' className={classes.notificationPageLabel}>{notification_attributes.supervision_certificate_number}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="supervision_certificate_number"
                        name="supervision_certificate_number"
                        margin="dense"
                        value={this.state.notification_form.supervision_certificate_number}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='supervision_certificate_category' className={classes.notificationPageLabel}>Какой категории?</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        placeholder="первой"
                        id="supervision_certificate_category"
                        name="supervision_certificate_category"
                        margin="dense"
                        value={this.state.notification_form.supervision_certificate_category}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />  </Paper> <Paper style={{padding:"1em", marginBottom: "1em"}}>
                    <Typography variant="h6" componrnt="h3">{blocks.author_supervisor_data}</Typography>
                    <InputLabel htmlFor='author_supervision_name' className={classes.notificationPageLabel} >{notification_attributes.author_supervision_name}</InputLabel>
                        <TextField
                            onChange={e => this.updateInput(e.target)}
                            fullWidth
                            id="author_supervision_name"
                            name="author_supervision_name"
                            margin="dense"
                            value={this.state.notification_form.author_supervision_name}
                            InputLabelProps={{shrink: true,}}
                        />
                    <InputLabel htmlFor='author_supervision_country' className={classes.notificationPageLabel} >{notification_attributes.author_supervision_country}</InputLabel>
                        <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="author_supervision_country"
                        name="author_supervision_country"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_country}
                        InputLabelProps={{shrink: true,}}
                    />
                    <InputLabel htmlFor='author_supervision_state' className={classes.notificationPageLabel} >{notification_attributes.author_supervision_state}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="author_supervision_state"
                        name="author_supervision_state"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_state}
                        InputLabelProps={{shrink: true,}}
                    />
                    <InputLabel htmlFor='author_supervision_region' className={classes.notificationPageLabel} >{notification_attributes.author_supervision_region}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="author_supervision_region"
                        name="author_supervision_region"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_region}
                        InputLabelProps={{
                            shrink: true,
                          }}
                    />
                    <InputLabel htmlFor='author_supervision_city' className={classes.notificationPageLabel}>{notification_attributes.author_supervision_city}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="author_supervision_city"
                        name="author_supervision_city"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_city}
                        InputLabelProps={{ shrink: true,}}
                    />
                    <InputLabel htmlFor='author_supervision_street' className={classes.notificationPageLabel}>{notification_attributes.author_supervision_street}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="author_supervision_street"
                        name="author_supervision_street"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_street}
                        InputLabelProps={{shrink: true,}}
                    />
                    <InputLabel htmlFor='author_supervision_phone' className={classes.notificationPageLabel}>{notification_attributes.author_supervision_phone}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        placeholder="+375111111111"
                        id="author_supervision_phone"
                        name="author_supervision_phone"
                        placeholder="+375111111111"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_phone}
                        InputLabelProps={{ shrink: true,}}
                    />
                    <InputLabel htmlFor='author_supervision_complexity_class' className={classes.notificationPageLabel}>{notification_attributes.author_supervision_complexity_class}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="author_supervision_complexity_class"
                        name="author_supervision_complexity_class"
                        margin="dense"
                        value={this.state.notification_form.author_supervision_complexity_class}
                        InputLabelProps={{shrink: true}}
                    />    </Paper> <Paper style={{padding:"1em", marginBottom: "1em"}}>

                    <Typography variant="h6">{blocks.budget_data}</Typography>
                    <InputLabel htmlFor='estimated_budget' className={classes.notificationPageLabel}>{notification_attributes.estimated_budget}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="estimated_budget"
                        name="estimated_budget"
                        maxLength={10}
                        margin="dense"
                        value={this.state.notification_form.estimated_budget}
                        InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='state_budget' className={classes.notificationPageLabel}>{notification_attributes.state_budget}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="state_budget"
                        maxLength={10}
                        name="state_budget"
                        margin="dense"
                        value={this.state.notification_form.state_budget}
                        InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='other_sources_budget' className={classes.notificationPageLabel} >{notification_attributes.other_sources_budget}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="other_sources_budget"
                        name="other_sources_budget"
                        margin="dense"
                        maxLength={10}
                        value={this.state.notification_form.other_sources_budget}
                        InputLabelProps={{shrink: true}}
                    />

                    <Typography variant="h6">{blocks.targeted_contributions}</Typography>
                    <InputLabel htmlFor='earmarked_contributions' className={classes.notificationPageLabel}>{notification_attributes.earmarked_contributions}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        id="earmarked_contributions"
                        name="earmarked_contributions"
                        margin="dense"
                        maxlength={10}
                        value={this.state.notification_form.earmarked_contributions}
                        InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='payment_order_index' className={classes.notificationPageLabel} >{notification_attributes.payment_order_index}</InputLabel>
                    <TextField
                        onChange={e => this.updateInput(e.target)}
                        fullWidth
                        id="payment_order_index"
                        name="payment_order_index"
                        value={this.state.notification_form.payment_order_index}
                        InputLabelProps={{shrink: true}}
                    />
                    <InputLabel htmlFor='payment_order_date' className={classes.notificationPageLabel} >{notification_attributes.payment_order_date}</InputLabel>
                    <DatePicker
                        onChange={this.updatePaymentOrderDate}
                        fullWidth
                        format='DD.MM.YYYY'
                        id="payment_order_date"
                        name="payment_order_date"
                        value={this.state.notification_form.payment_order_date}
                        InputLabelProps={{ shrink: true }}
                    /> </Paper>
                            <Paper style={{padding:'2em'}}>
                                <InputLabel htmlFor='description' className={classes.notificationPageLabel}><sup>1</sup>{notification_attributes.description}</InputLabel>
                                <TextField
                                    onChange={e => this.updateInput(e.target)}
                                    fullWidth
                                    multiline={true}
                                    rows={3}
                                    id="description"
                                    name="description"
                                    value={this.state.notification_form.description}
                                    InputLabelProps={{shrink: true}}
                                />
                            </Paper>
                    </fieldset>
                </form>
                    <Typography style={{color:"red"}}>{this.state.message} {this.props.message}</Typography>
                    </Paper>

</main>
                <object type="application/x-java-applet" height="60" id="appletAvSend">
                    <param name="code" value="appletAvSend"/>
                    <param name="archive" value="appletAvSend.jar,jna-3.0.9.jar"/>
                    <param name="codebase" value="/applet/"/>
                    <param name="huhuid"/>
                    <Chip color='primary' style={{margin:'2em'}}
                          label="Ошибка загрузки апплета. Java plug-in не найден"/>
                </object>

                {(this.props.notification_form.status !== 'SIGNED') &&(<div>

                {(this.state.notification_form.status ==  'CREATED' || this.state.notification_form.status == 'DRAFT') && (<Button color="primary" onClick={this.handleDelete}>Удалить</Button>)}
                <Button color="primary" onClick={this.handleSave}>Сохранить</Button>
                {('eds_name' in this.state.user) && (
                <Button disabled={this.state.sendDisabled} color="primary" onClick={this.handleClickOpen}>Подписать и отправить</Button>
                )}
                </div>)}

                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Отправка уведомления на подпись</DialogTitle>
                    <DialogContent>
                        {this.state.pogress &&<LinearProgress variant="query" />}
                        <DialogContentText style={{color:'red'}}>
                            {this.state.sign_message}
                        </DialogContentText>

                        <TextField
                            autoFocus
                            name="notification_password_crypto"
                            margin="dense"
                            id="notification_password_crypto"
                            label="Пароль к криптоконтейнеру"
                            type="password"
                            onChange={e => this.onFileFormChange(e.target)}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Закрыть
                        </Button>
                        <Button onClick={this.handleSendFile} color="primary">
                            Подписать и Отправить
                        </Button>
                    </DialogActions>
                </Dialog>
                <Paper style={{ margin: '20px', padding: '1em'}}>
                    {this.props.attachments.length > 0 && (<Typography component="p"  style={{margin: '20px',fontSize:  '1.4em'}}>Документы</Typography> )}
                 {this.props.attachments.length > 0 && (this.props.attachments.map(item => (
                     <Typography component="p" style={{margin: '20px'}}>
                         <a href={`/uploads/files/${item.file_name}`} target='_blank'>{item.file_name.replace(/^.*[\\\/]/, '')}</a>
                     </Typography>
                 )))}
                    { this.props.notification_form.status !== 'SIGNED' && (<Typography component="div">
                {this.state.fileUploadOpen == false && (<Button onClick={this.showForm}><Attachment  /></Button>)}
                {this.state.fileUploadOpen && (
                    <form encType='multipart/form-data' id='fileUpload' onSubmit={this.fileUpload} style={{padding:'1em'}}>
                        <InputLabel htmlFor='attachment'
                                    className={classes.notificationPageLabel}
                                    required>{'Только для сопутствующих документов. Бумажную версию уведомления не пересылать'}</InputLabel>

                        <input type='file' name='attachment' id='attachment' />
                        <Button type='submit'>Загрузить</Button>
                    </form>
                )}
                </Typography>)}
                </Paper>
                <Footer />
            </div>
        );
    }
}

Notification.defaultProps = {
    open: false,
    status: 'new',
    message:'',
    fetching: false,
    response_status:'',
    disabled: false,
    inspections:[],
    redirect: null,
    attachments: []
}

function select(state, props) {
    const {notifications, message} = state;
    console.log('SELECT');
    if (typeof notifications !== "undefined") {
        return {
            status: ('status' in notifications)? notifications.status: 'new' ,
            message: ('message' in notifications)? notifications.message:'',
            fetching:('fetching' in notifications)?  notifications.fetching:'',
            response_status: ('response_status' in notifications)?notifications.response_status:'',
            notification_form: ('item' in notifications )? notifications.item : {},
            document_url: ('item' in notifications )? notifications.url : {},
            open: ('open' in notifications)? notifications.open: false,
            disabled: ('disabled' in notifications) ? notifications.disabled: false,
            redirect: ('redirect' in notifications) ? notifications.redirect: null,
            inspections: ('inspections' in notifications) ? notifications.inspections: [],
            attachments: ('attachments' in notifications) ? notifications.attachments: [],

        };
    } else {
        return {
            redirect: null,
            inspections: [],
            open: false,
            status: 'new',
            message: '',
            fetching: false,
            response_status: '',
            disabled: false,
            notification_form: {status: 'UNDEFINED'}
        }
    }
}

function mapDispatch(dispatch) {
    return {
        deleteNotification: bindActionCreators(deleteNotification, dispatch),
        clearRedirect: bindActionCreators(clearRedirect, dispatch),
        getNotification: bindActionCreators(getNotification, dispatch),
        saveNotification: bindActionCreators(saveNotification, dispatch),
        uploadFile:  bindActionCreators(uploadFile, dispatch),
        removeUnsentFile: bindActionCreators(removeUnsentFile, dispatch),
        setNotificationSigned: bindActionCreators(setNotificationSigned, dispatch),
        loadInspections: bindActionCreators(loadInspectionsList, dispatch),
        logout: bindActionCreators(logout, dispatch),
        getAttachments: bindActionCreators(getAttachments, dispatch),
        addAttachment: bindActionCreators(addAttachment, dispatch),
        removeAttachment: bindActionCreators(removeAttachment, dispatch)
    };
}
export const NotificationWithStyles = withStyles(styles)(Notification);
export default connect(select, mapDispatch)(NotificationWithStyles);


// WEBPACK FOOTER //
// ./assets/src/js/components/pages/Notification.jsx